import watchPersonalInfo from './personalInfo'

export default watchPersonalInfo
